import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";

// Firebase Configuration from Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyCE3oG0VxuFZW2khVwfJNI0oANvfIhtSik",
  authDomain: "ytnkio-b9f02.firebaseapp.com",
  projectId: "ytnkio-b9f02",
  storageBucket: "ytnkio-b9f02.firebasestorage.app",
  messagingSenderId: "820535920295",
  appId: "1:820535920295:web:1327cfd7f9c7b5734c7d82"
};

// Initialize Firebase (singleton pattern)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Firebase Auth
const auth = getAuth(app);

// Export for use in the app
export { app, auth };
export default app;
